import { NgModule } from '@angular/core';

import { ParseDurationPipe } from './format-duration.pipe';

@NgModule({
  declarations: [ParseDurationPipe],
  exports: [ParseDurationPipe],
})
/**
 * Module with the duration pipe
 */
export class ParseDurationPipeModule {}
